import Vue from 'vue';
import Vuex from 'vuex';
import config from 'config';
import * as GETTERS from './constants/getters.js';
import * as ROUTES from '@/constants/routes.js';
import { content } from './modules/content/module.js';
import { followers } from './modules/followers/module.js';
import { language } from './modules/language/module.js';
import { pages } from './modules/pages/module.js';
import { queues } from './modules/queues/module.js';
import { searches } from './modules/searches/module.js';
import { users } from './modules/users/module.js';
import { workspaces } from './modules/workspaces/module.js';
import { clients } from './modules/clients/module.js';
import { sites } from './modules/sites/module.js';
import { time, timePlugin } from './modules/time/module.js';
import { quick_searches } from './modules/quick_searches/module.js';
import { navigation } from './modules/navigation/module.js';
import { version, versionPlugin } from './modules/version/module.js';
import { ui } from './modules/ui/module.js';

Vue.use(Vuex);

export const initializeStore = (response) => {
    const [
        settings, // eslint-disable-line no-unused-vars
        sectionTree, // eslint-disable-line no-unused-vars
    ] = response;

    const vuexStore = new Vuex.Store(storeConfig());

    if (!config.isProduction) {
        window.vuexStore = vuexStore;
    }

    return vuexStore;
};

export const storeConfig = () => ({
    plugins: [ timePlugin, versionPlugin ],
    getters: {
        [GETTERS.CURRENT_WORKSPACE_UUID](state) {
            return state.route ? state.route.params.workspace_uuid : undefined;
        },

        [GETTERS.CURRENT_QUEUE_UUID](state) {
            return state.route ? state.route.params.queue_uuid : undefined;
        },

        [GETTERS.CURRENT_SEARCH_UUID](state) {
            return state.route ? state.route.params.saved_search_uuid : undefined;
        },
        [GETTERS.CURRENT_ROUTE](state) {
            return state.route ? state.route.name : undefined;
        },
        [GETTERS.CURRENT_ROUTE_NAME](state, getters) {
            switch (getters[GETTERS.CURRENT_ROUTE]) {
                case ROUTES.QUEUE:
                    const currentQueue = getters[GETTERS.CURRENT_QUEUE];
                    return currentQueue ? currentQueue.name : '';
                case ROUTES.SEARCH:
                    const currentSearch = getters[GETTERS.CURRENT_SEARCH];
                    return currentSearch ? currentSearch.name : '';
                case ROUTES.WORKSPACE:
                    const currentWorkspace = getters[GETTERS.CURRENT_WORKSPACE];
                    return currentWorkspace ? currentWorkspace.name : '';
                default:
                    return '';
            }
        },
    },
    modules: {
        clients: clients(),
        content: content(),
        followers: followers(),
        language: language(),
        pages: pages(),
        queues: queues(),
        searches: searches(),
        sites: sites(),
        users: users(),
        workspaces: workspaces(),
        time: time(),
        quickSearches: quick_searches(),
        navigation: navigation(),
        version: version(),
        ui: ui(),
    },
});
